import React from 'react';
import SectorContentBox from './SectorContentbox';
import content from './PagesContent/content';
import SectorFirstPage from './SectorFirstPage';
import SectorCarousal from '../carousal/SectorCarousal';

export default function FoodSector() {
    return (
        <>
            <SectorFirstPage content={content.page7} />
            {content.page7.contentpage.map((element, index) => (
                <React.Fragment key={index}>
                    <SectorContentBox pagecontent={element} />
                    <hr />
                </React.Fragment>
            ))}
            <SectorCarousal removeroute={"/food"}/>
        </>
    );
}
